<template>
<div v-once id="quickemail">  
 

<!--MV-->
	<section class="hero">
		<div class="wrapper sp">
			<img src="/static/renew_img/quickemail/mv01.png" alt="ユーザーの皆さんの声をカタチにしました！" class="mv01">
			<div class="voice">
				<img src="/static/renew_img/quickemail/mv02.png" alt="履歴書をそのまま送りたい！" class="voice_img">
				<div class="voice_list">
					<p>「企業先にメールで送りたいです」</p>
					<p>「登録したメアドって自分のメアドですか？」</p>
					<p>「応募先のメールへ送信したい」</p>
				</div>
			</div>
			<div class="yagideco01">
				<img src="/static/renew_img/quickemail/mv04.png" alt="ヤギのメール便始めました" class="yagideco01_01">
				<img src="/static/renew_img/quickemail/mv05.png" alt="面倒な作業一切なし！！" class="yagideco01_02">
			</div>
		</div>
		<div class="wrapper pc">
			<img src="/static/renew_img/quickemail/mv06.png" alt="始めましたヤギのメール便" class="mv06">
			<div class="yagideco01">
				<img src="/static/renew_img/quickemail/mv04.png" alt="ヤギのメール便始めました" class="yagideco01_01">
			</div>
		</div>
	</section>

	<div class="cv-block">
		<img src="/static/renew_img/quickemail/nedan03_20230630.png" alt="330円" class="cv-img">
		<p class="cv-txt01">「履歴書をメールで送って」</p>
		<p class="cv-txt02">↓↓↓と企業から指示があったなら↓↓↓</p>
		<a href="https://rirekisho.yagish.jp/quickemail/basic" target="_blank" class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic">ヤギのメール便<span class="cv-btn_small">をつかう</span></a>
	</div>
	
<!--アピールポイント-->
	<section class="second">
		<h2 class="h2">こんなに機能充実！</h2>
		<div class="wrapper sp-flex pr_block">
			<img src="/static/renew_img/quickemail/pr01.png" alt="いつも通り作成するだけ" class="pr_item">
			<img src="/static/renew_img/quickemail/pr02.png" alt="企業が確認すると通知が来る" class="pr_item">
			<img src="/static/renew_img/quickemail/pr03.png" alt="間違った、送信取消OK" class="pr_item">
			<img src="/static/renew_img/quickemail/pr04.png" alt="パスワード付でセキュリティ◎" class="pr_item">
		</div>
	</section>
	
	<!--使い方-->
	<section class="third">
		<div class="wrapper">
			<h2 class="h2">ヤギのメール便の使い方</h2>
			<ul class="step">
				<li class="sp-flex step_item">
					<p class="step_number">①</p>
					<p>いつも通りヤギッシュで<br class="sp"><span class="step_bold">履歴書・職務経歴書を作成！</span></p>
				</li>
				<li class="sp-flex step_item">
					<p class="step_number">②</p>
					<p>ヤギのメール便をつかって<br class="sp"><span class="step_bold">応募先企業の情報を入力</span></p>
				</li>
				<li class="step_item">
					<div class="sp-flex step_item_03">
						<p class="step_number">③</p>
						<p>ヤギのメール便「購入」と同時に<br class="sp"><span class="step_bold">応募先企業に送信完了！</span></p>
					</div>
					<div class="preview01">
						<p class="preview_ti">送信メール画面</p>
						<img src="/static/renew_img/quickemail/preview01.png" alt="送信メール画面" class="preview_img01">
						<p class="step_small preview01_txt">※お使いのメールソフトによって画面が異なる場合がございます。ご了承ください。</p>
					</div>
					<div class="preview02">
						<p class="preview_ti">企業側ダウンロード画面</p>
						<img src="/static/renew_img/quickemail/preview02.png" alt="企業側ダウンロード画面" class="preview_img02">
					</div>
				</li>
				<li class="sp-flex step_item">
					<p class="step_number">④</p>
					<p>応募先企業があなたのPDFを見ると<br class="sp"><span class="step_bold">メールで通知が来るよ！</span><br>
						<span class="step_small">※閲覧通知は選考の合否とは関係がありません。企業によって選考の流れや連絡方法などは異なります。</span></p>
				</li>
			</ul>
		</div>
	</section>

	<div class="cv-block cv-block02">
		<img src="/static/renew_img/quickemail/nedan04_20230630.png" alt="330円" class="cv-img">
		<a href="https://rirekisho.yagish.jp/quickemail/basic" target="_blank" class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic">ヤギのメール便<span class="cv-btn_small">をつかう</span></a>
	</div>
	
	<div style="text-align: center; padding: 20px;">
		<a href="/quickemailterms" target="_blank">利用規約は<span style="color: #E3165C;">こちら</span></a>
	</div>

</div>
</template>
<style lang="css" src="@/assets/css/quickemail_stylesheet.css"></style>
<style lang="css" src="@/assets/css/quickemail_reset.css"></style>

<style lang="scss" scoped>

</style>

<script>
export default {
  data: function () {
    return {
      question1:false,
      question2:false,
      question3:false,
      question4:false,
      question5:false,
      question6:false,
      question7:false,
      question8:false
    }
  },
  computed: {},
  methods: {
    viewAnswer: function(name) {
      console.error(name)
      this.question1 = true
    }
  },
  watch: {},
  mounted: function () {}
}
</script>
